const initialState = [];

const leadConvertTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LEADCONVERTTYPES":
            return (state = action.payload);
        default:
            return state;
    }
};


export default leadConvertTypeReducer;